import { dom, library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import '../components/modals/FeaturesPopup/permissionsForcedModeController'

export function loadFontAwesome() {
  // @ts-ignore
  library.add(fas, far)
  dom.watch()
}
